import { encodePaginatableQuery, PaginatableQuery, Query, SortableQuery } from '@/services/api';
import * as q from '@/services/api/request/query';

export interface QuestionQuery extends PaginatableQuery, SortableQuery {
  timezone: string;
  start: Date | null;
  end: Date | null;
  entityItem: number[];
  group: number[];
  inspector: number[];
  category: number[];
  checklist: number[];
  question: string[];
  questionTitle: string[];
  response: string[];
  inspection: number[];
  section: string[];
  hasScore: boolean;
  negative: boolean;
  search: string;
}

export const encodeQuestionQuery = (query: QuestionQuery): Query => ({
  ...encodePaginatableQuery(query),
  timezone: q.string(query.timezone),
  sort: query.sort ? q.sortEncoder(query.sort, query.dir) : '',
  from: q.nullableDate(query.start),
  to: q.nullableDate(query.end),
  entityItem: q.numbers(query.entityItem),
  group: q.numbers(query.group),
  inspector: q.numbers(query.inspector),
  category: q.numbers(query.category),
  checklist: q.numbers(query.checklist),
  question: q.strings(query.question),
  questionTitle: q.strings(query.questionTitle),
  response: q.strings(query.response),
  inspection: q.numbers(query.inspection),
  section: q.strings(query.section),
  hasScore: q.boolean(query.hasScore),
  negative: q.boolean(query.negative),
  search: q.string(query.search),
});
